import { updateRecordInStore } from 'utils/redux';
import {
  CREATE_SEQUENCE,
  GET_SEQUENCE,
  UPDATE_SEQUENCE,
  GET_SEQUENCES,
  CLEAR_SEQUENCE_STORE,
  DUPLICATE_SEQUENCE,
} from '../actions/sequenceActions';


const initialState = {
  sequence: {
    loading: true,
    loaded: false,
    id: null,
    name: '',
    account_id: null,
    campaign: null,
    status: null,
    stat_people: 0,
    stat_opens: 0,
    stat_replies: 0,
    stat_delivered: 0,
    stat_interested: 0,
    allow_duplicates: false,
    steps_sent_progress: 0,
    validate_contacts: null,
    send_to_risky: null,
  },
  sequences: {
    loading: false,
    loaded: true,
    results: [],
  },
};


export const sequenceReducer = (state = initialState.sequence, action) => {
  switch (action.type) {
    case CLEAR_SEQUENCE_STORE:
      return {
        loading: false,
        loaded: true,
      };
    case CREATE_SEQUENCE.pending:
      return {
        loading: true,
        loaded: false,
      };
    case CREATE_SEQUENCE.error:
      return {
        loading: false,
        loaded: true,
        ...action.payload.data,
      };
    case CREATE_SEQUENCE.success:
      return {
        loading: false,
        loaded: true,
        ...action.payload.data,
      };
    case GET_SEQUENCE.pending:
      return {
        loading: true,
        loaded: false,
      };
    case GET_SEQUENCE.error:
      return {
        loading: false,
        loaded: true,
        ...action.payload.data,
      };
    case GET_SEQUENCE.success:
      return {
        loading: false,
        loaded: true,
        ...(action.payload ? action.payload.data : {}),
      };
    case UPDATE_SEQUENCE.pending:
      return {
        ...state,
        loading: true,
        loaded: false,
        ...action.payload,
      };
    case UPDATE_SEQUENCE.error:
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload.data,
      };
    case UPDATE_SEQUENCE.success:
      return {
        loading: false,
        loaded: true,
        ...action.payload.data,
      };
    case DUPLICATE_SEQUENCE.pending:
      return {
        loading: true,
        loaded: false,
        ...action.payload,
      };
    case DUPLICATE_SEQUENCE.success:
      return {
        loading: false,
        loaded: true,
        ...action.payload.data,
      };
    case DUPLICATE_SEQUENCE.error:
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload.data,
      };
    default:
      return state;
  }
};


export const sequencesReducer = (state = initialState.sequences, action) => {
  switch (action.type) {
    case GET_SEQUENCES.pending:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case GET_SEQUENCES.error:
      return {
        loading: false,
        loaded: true,
        ...action.payload.data,
      };
    case GET_SEQUENCES.success:
      return {
        loading: false,
        loaded: true,
        ...action.payload.data,
      };
    case UPDATE_SEQUENCE.success:
      return {
        loading: false,
        loaded: true,
        results: updateRecordInStore(
          r => r.id === action.payload.data.id,
          state.results,
          action.payload.data,
        ),
      };
    default:
      return state;
  }
};
